import { reactive, unref } from 'vue'

export const createModel = (models: Array<any>) => {
  const formModel = {}
  for (const model of models) {
    formModel[model.prop] = model.model
  }
  return formModel
}

export const formModel = (props: any) => {
  const formModel = reactive({})
  Object.assign(formModel, unref(props.formModel))
  return formModel
}

export interface FormItemComponentModel {
  prop: string
  label: string | null
  placeholder?: string | null
  component: 'el-input' | 'el-select' | string
  type: string
  model: any
  min?: number | null
  max?: number | null
  disabled?: boolean | null
  multiple?: boolean | null
  filterable?: boolean | null
  readonly?: boolean | null
  remote?: boolean | null
  loading?: boolean | null
  remoteMethod?: Function | null
  options?: Array<any> | null
}
export function CreateFormStruct(modles: Array<string>) {
  const Structs = new Array<FormItemComponentModel>()
  for (const iterator of modles) {
    const structt: FormItemComponentModel = {
      prop: iterator,
      label: null,
      component: 'el-input',
      type: 'text',
      model: ''
    }
    Structs.push(structt)
  }
  return Structs
}
